import { Link } from "react-router-dom";

/**
 * Shared brand lockup: the gold "Hayat Ağacı" (tree of life) icon mark + "ABDULLAH KARSLI"
 * wordmark + tagline. Used in the Navbar, Footer, Admin sidebar and Admin login screen so
 * the same clean icon appears everywhere.
 */
export const BrandLogo = ({
  to = "/",
  asLink = true,
  stacked = false,
  iconClassName = "h-10 md:h-[45px] w-auto",
  nameClassName = "text-lg md:text-xl",
  showTagline = true,
  taglineClassName = "text-[9px] md:text-[10px]",
  linkTestId,
  imgTestId,
  className = "",
  onClick,
}) => {
  const inner = (
    <div
      className={`flex items-center gap-2.5 ${stacked ? "flex-col text-center gap-2" : ""} ${className}`}
    >
      <img
        data-testid={imgTestId}
        src="/assets/logo1.png"
        alt="Abdullah Karslı Gayrimenkul Danışmanlığı"
        className={`${iconClassName} object-contain shrink-0`}
      />
      <div className={`flex flex-col leading-tight ${stacked ? "items-center" : ""}`}>
        <span className={`font-[var(--font-serif)] font-semibold tracking-[0.05em] text-[color:var(--brand-charcoal)] ${nameClassName}`}>
          ABDULLAH KARSLI
        </span>
        {showTagline && (
          <span
            className={`font-medium tracking-[0.1em] text-[color:hsl(var(--muted-foreground))] whitespace-nowrap ${taglineClassName}`}
          >
            Gayrimenkul Danışmanlığı
          </span>
        )}
      </div>
    </div>
  );

  if (!asLink) return inner;

  return (
    <Link to={to} data-testid={linkTestId} className="flex items-center shrink-0" onClick={onClick}>
      {inner}
    </Link>
  );
};

export default BrandLogo;
